import { Badge } from "@/components/ui/badge";
import { daysLeft } from "@/lib/fmt";

const STATUS = {
  open: ["Aktif", "bg-blue-50 text-blue-700 border-blue-200"],
  expired: ["Expired", "bg-slate-100 text-slate-600 border-slate-300"],
  deal: ["Deal", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  lost: ["Lost", "bg-rose-50 text-rose-700 border-rose-200"],
  draft: ["Draft", "bg-amber-50 text-amber-700 border-amber-200"],
  converted: ["Sudah Convert", "bg-emerald-50 text-emerald-700 border-emerald-200"],
};

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = STATUS[status] || [status, "bg-slate-100 text-slate-600"];
  return <Badge data-testid={testId} variant="outline" className={`${cls} font-semibold`}>{label}</Badge>;
};

export const RiskBadge = ({ level }) => {
  const cls = { High: "bg-rose-50 text-rose-700 border-rose-200", Medium: "bg-amber-50 text-amber-700 border-amber-200", Low: "bg-emerald-50 text-emerald-700 border-emerald-200" }[level] || "";
  return <Badge variant="outline" className={`${cls} font-semibold`}>{level || "-"}</Badge>;
};

export const VersionBadge = ({ q }) => (
  <Badge variant="outline" className={q.kind === "nego" ? "bg-amber-50 text-amber-700 border-amber-300" : q.rev_no > 0 ? "bg-rose-50 text-rose-700 border-rose-200" : "bg-slate-50 text-slate-700"}>
    {q.version_label}
  </Badge>
);

export const Validity = ({ until, status }) => {
  if (status !== "open") return <span className="text-xs text-slate-400">-</span>;
  const d = daysLeft(until);
  const cls = d <= 2 ? "text-rose-600 bg-rose-50" : d <= 4 ? "text-amber-700 bg-amber-50" : "text-emerald-700 bg-emerald-50";
  return <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${cls}`}>{d > 0 ? `${d} hari lagi` : "Hari ini"}</span>;
};

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-8 fade-up">
    <div>
      <h1 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900">{title}</h1>
      {subtitle && <p className="mt-1.5 text-sm text-slate-500">{subtitle}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const Field = ({ label, children, className = "" }) => (
  <label className={`flex flex-col gap-1.5 ${className}`}>
    <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</span>
    {children}
  </label>
);

export const Empty = ({ text = "Belum ada data" }) => <div className="py-14 text-center text-sm text-slate-400">{text}</div>;
